// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_StatsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/links/stats
 *
 * Returns aggregate counts and totals for the active franchise's payment links
 * within the requested date range. Shape mirrors payment_links_model::getStatsByFranchise.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsLinks_StatsResponseDados = unknown[];

export type SubaccountsLinks_StatsResponse = ApiResponse<SubaccountsLinks_StatsResponseDados>;

registerResponseContract('SubaccountsLinks_StatsResponse', {})
